import { ActionTree } from 'vuex';
import { BoardsGroupModel, BoardsGroupInfo } from '@descomplica/dex-models';

import { graphqlMutation, graphqlQuery, ServicesEnum } from '@/helpers/graphql';
import RootState from '@/store/root_state';
import { BoardsGroupState } from './state';

const actions: ActionTree<BoardsGroupState, RootState> = {
  async PULL_BOARDS_GROUPS_BY_COURSE_ID({ commit }, courseId: number) {
    const response = await graphqlQuery(
      ServicesEnum.BOARDS_GROUPS,
      `query getBoardsGroupsByCourseId($courseId: Int!){
        getBoardsGroupsByCourseId(courseId: $courseId){
          id
          name
          description
          courseId
          groups {
            id
            name
            description
            boardIds
            boardsGroupId
            position
          }
        }
      }`,
      {
        courseId,
      },
    );

    const boardsGroups = response && response.data.getBoardsGroupsByCourseId;
    if (!boardsGroups) return;

    commit('SET_BOARDS_GROUPS', boardsGroups);
    commit(
      'SET_GROUPS',
      boardsGroups
        .map((boardsGroup: BoardsGroupModel) => boardsGroup.groups)
        .flat(),
    );
  },

  async CREATE_BOARDS_GROUP(_, boardsGroupInfo: Partial<BoardsGroupInfo>) {
    return await graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation createBoardsGroup($boardsGroupInfo: CreateBoardsGroupMutationInput!) {
        createBoardsGroup (data: $boardsGroupInfo) {
          id
          name
          description
          courseId
          groups {
            id
            name
            description
            boardIds
            boardsGroupId
          }
        }
      }
      `,
      {
        boardsGroupInfo,
      },
    );
  },
  async UPDATE_BOARDS_GROUP(
    _,
    {
      boardsGroupId,
      boardsGroupInfo,
    }: {
      boardsGroupId: number;
      boardsGroupInfo: Partial<BoardsGroupInfo>;
    },
  ) {
    return graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation updateBoardsGroup($boardsGroupId: Float!, $boardsGroupInfo: UpdateBoardsGroupMutationInput!) {
        updateBoardsGroup (boardsGroupId: $boardsGroupId, data: $boardsGroupInfo) {
          id
          name
          description
          courseId
          groups {
            id
            name
            description
            boardIds
            boardsGroupId
            position
          }
        }
      }
      `,
      {
        boardsGroupId,
        boardsGroupInfo,
      },
    );
  },
  async REMOVE_BOARDS_GROUPS({ commit }, boardsGroupId: number) {
    await graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation deleteBoardsGroup($boardsGroupId: Float!) {
        deleteBoardsGroup (boardsGroupId: $boardsGroupId)
      }
      `,
      {
        boardsGroupId,
      },
    );

    commit('CLEAN_BOARDSGROUP_STATE', boardsGroupId);
  },
};

export default actions;
